import React from 'react';
import FormInput from 'src/components/form-input';
import { hasVariable } from 'src/utils/wizard';
import { twMerge } from 'tailwind-merge';

interface WizardIpRowProps {
  id: string;
  ip: string;
  subnetMask: string;
  onChangeIp: (ip: string) => void;
  onChangeSubnetMask: (subnetMask: string) => void;
}

export default function WizardIpRow({
  id,
  ip,
  subnetMask,
  onChangeIp,
  onChangeSubnetMask,
}: WizardIpRowProps) {
  const activeIp = hasVariable(ip);
  const activeSubnetMask = hasVariable(subnetMask);

  return (
    <>
      <td className="border-r border-gray-200 p-1">
        <FormInput
          id={`wizard-switch-ip-${id}`}
          className={twMerge([activeIp && 'border-green-500 bg-green-500/50'])}
          name={`wizard-switch-ip-${id}`}
          value={ip}
          onChange={(e) => {
            const { value } = e.target;
            onChangeIp(value);
          }}
        />
      </td>
      <td className="p-1">
        <FormInput
          id={`wizard-switch-subnet-mask-${id}`}
          className={twMerge([
            activeSubnetMask && 'border-green-500 bg-green-500/50',
          ])}
          name={`wizard-switch-subnet-mask-${id}`}
          value={subnetMask}
          onChange={(e) => {
            const { value } = e.target;
            onChangeSubnetMask(value);
          }}
        />
      </td>
    </>
  );
}
